import twitterIcon from '../../images/Footer/twitter.svg';
import pinterestIcon from '../../images/Footer/pinterest.svg';
import instagramIcon from '../../images/Footer/instagram.svg';
import facebookIcon from '../../images/Footer/facebook.svg';
import spotifyIcon from '../../images/Footer/spotify.svg';
import tiktokIcon from '../../images/Footer/tiktok.svg';

export const socialMediaIcons = [
  {
    src: instagramIcon,
    alt: 'Instagram icon',
    href: 'https://www.instagram.com/ollie/',
  },
  {
    src: facebookIcon,
    alt: 'Facebook icon',
    href: 'https://www.facebook.com/MyOllie',
  },
  {
    src: twitterIcon,
    alt: 'Twitter icon',
    href: 'https://twitter.com/olliepets',
  },
  {
    src: tiktokIcon,
    alt: 'Tiktok icon',
    href: 'https://www.tiktok.com/@olliepets',
  },
  {
    src: pinterestIcon,
    alt: 'Pinterest icon',
    href: 'https://www.pinterest.com/myolliedotcom/',
  },
  {
    src: spotifyIcon,
    alt: 'Spotify icon',
    href: 'https://open.spotify.com/user/ski5m70d8oulhj06d5ss6w1xm',
  },
];
